<template>
	<el-card class="box-card">
		<el-row>
			<el-col :span="8" :offset="2">
				<el-form label-position="right" label-width="100px">
					<el-form-item label="账户余额:">
						<el-col :span="16">
							<span style="color:red">{{balance}}</span>
						</el-col>
					</el-form-item>
					<el-form-item label="提现账户:">
						<el-col :span="16">
							<el-select v-model="form.type" placeholder="请选择">
								<el-option v-for="item in account" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-col>
					</el-form-item>
					<el-form-item label="提现金额">
						<el-col :span="16">
							<el-input-number v-model="form.money" :precision="2" :step="100" :min="0.00">
							</el-input-number>
						</el-col>
					</el-form-item>
				</el-form>
				<el-button :loading="this.$store.state.ajaxLoading" @click="set" style="margin-left: 100px;" type="primary">提交</el-button>
			</el-col>
		</el-row>
	</el-card>

</template>

<script>
	import {
		withdrawalInit,
		withdrawal
	} from '@/api/jd_task'
	import Qs from 'qs'
	export default {
		data() {
			return {
				balance:'0.00',
				account:{},
				form: {
					type: '',
					money: '',
				},
			}
		},
		created() {
			this.getData();
		},
		methods: {
			getData() {
				withdrawalInit(Qs.stringify()).then(response => {
					let r = response.result;
					this.balance = r.balance;
					this.account = r.account;
				})
			},
			set() {
				this.$store.commit('setAjaxLoading', true);
				withdrawal(Qs.stringify(this.form)).then(response => {
					this.$message({
						showClose: true,
						message: '提交成功，请等待审核',
						type: 'success'
					});
					location.reload();
				})
			},
		}
	}
</script>

<style>
</style>
